webpackJsonp([60569655691787],{

/***/ 1545:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ReminderInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"appointmentTypeIds","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"Int","ofType":null}}},{"defaultValue":null,"description":null,"name":"body","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"event","type":{"kind":"ENUM","name":"ReminderEvent","ofType":null}},{"defaultValue":null,"description":null,"name":"hoursAfter","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"defaultValue":null,"description":null,"name":"on","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"subject","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"type","type":{"kind":"ENUM","name":"ReminderType","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-reminder-input-488e7f4a806813f198cf.js